import React from 'react';
import { Tag } from '@indeed/ifl-components';
/**
 * Finds the first matching tag configuration based on location data
 * @param params - Object containing tag configs and location
 * @returns Matching tag config or null if none found
 */
const getMatchingTag = ({ customTags, location }) => {
    if (!(customTags === null || customTags === void 0 ? void 0 : customTags.length) || !location) {
        return null;
    }
    return customTags.find((tag) => tag.shouldRender(location)) || null;
};
/**
 * CustomTag Component
 * Renders a configurable tag with icon and label based on location data.
 * Supports conditional rendering through tag configurations.
 *
 * @example
 * ```tsx
 * const tagConfigs = [{
 *   label: "Premium",
 *   status: "success",
 *   icon: <StarIcon />,
 *   shouldRender: (location) => location.type === 'CITY'
 * }];
 *
 * <CustomTag
 *   customTags={tagConfigs}
 *   location={locationData}
 * />
 * ```
 */
export const CustomTag = ({ customTags, location }) => {
    const matchingTag = getMatchingTag({ customTags, location });
    if (!matchingTag) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { variant = 'light', status = 'info', icon, label, shouldRender, ...rest } = matchingTag;
    return (React.createElement(Tag, { variant: variant, status: status, ...rest },
        icon,
        label));
};
export default CustomTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tVGFnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xheW91dC9DdXN0b21UYWcudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMxQixPQUFPLEVBQUUsR0FBRyxFQUFZLE1BQU0sd0JBQXdCLENBQUM7QUEyQnZEOzs7O0dBSUc7QUFDSCxNQUFNLGNBQWMsR0FBRyxDQUFDLEVBQUUsVUFBVSxFQUFFLFFBQVEsRUFBa0IsRUFBMEIsRUFBRTtJQUN4RixJQUFJLENBQUMsQ0FBQSxVQUFVLGFBQVYsVUFBVSx1QkFBVixVQUFVLENBQUUsTUFBTSxDQUFBLElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQztRQUNuQyxPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0lBRUQsT0FBTyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUMsR0FBRyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDLElBQUksSUFBSSxDQUFDO0FBQ3hFLENBQUMsQ0FBQztBQUVGOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBbUJHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUE2QixDQUFDLEVBQUUsVUFBVSxFQUFFLFFBQVEsRUFBRSxFQUFFLEVBQUU7SUFDNUUsTUFBTSxXQUFXLEdBQUcsY0FBYyxDQUFDLEVBQUUsVUFBVSxFQUFFLFFBQVEsRUFBRSxDQUFDLENBQUM7SUFFN0QsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDO1FBQ2YsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUVELDZEQUE2RDtJQUM3RCxNQUFNLEVBQUUsT0FBTyxHQUFHLE9BQU8sRUFBRSxNQUFNLEdBQUcsTUFBTSxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFLEdBQUcsSUFBSSxFQUFFLEdBQUcsV0FBVyxDQUFDO0lBQy9GLE9BQU8sQ0FDSCxvQkFBQyxHQUFHLElBQUMsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxLQUFNLElBQUk7UUFDMUMsSUFBSTtRQUNKLEtBQUssQ0FDSixDQUNULENBQUM7QUFDTixDQUFDLENBQUM7QUFFRixlQUFlLFNBQVMsQ0FBQyJ9